import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useRecoilState } from 'recoil';
import { authState } from '../recoil';
import { postCallGetAccesToken, postCallRefreshUrl } from '../services';

/**
 * Access tokens expire six hours after they are created
 */
const staleTime = 5 * 60 * 60 * 1000; // 5 heures

export const useGetAccessToken = () => {
  const [authorization_code] = useRecoilState(authState);
  const [hasExpired, setHasExpired] = useState(false);

  const { data: response, isLoading } = useQuery({
    queryKey: ['tokens'],
    queryFn: () =>
      hasExpired
        ? postCallRefreshUrl()
        : postCallGetAccesToken(authorization_code || ''),
    staleTime,
    enabled: authorization_code !== null,
  });

  const access_token = response?.access_token;
  const expires_at = response?.expires_at;
  const expires_in = response?.expires_in;

  if (!authorization_code) {
    console.error('no authorization_code');
  }

  if (!access_token) {
    console.error('no access_token');
  }

  if (expires_in === 0) {
    console.error('access_token has expired');
    setHasExpired(true);
  }

  return { access_token, isLoading, expires_at, expires_in, hasExpired };
};
